import { render, staticRenderFns } from "./EditAppSection.vue?vue&type=template&id=00af7507&scoped=true"
import script from "./EditAppSection.vue?vue&type=script&lang=js"
export * from "./EditAppSection.vue?vue&type=script&lang=js"
import style0 from "./EditAppSection.vue?vue&type=style&index=0&id=00af7507&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00af7507",
  null
  
)

export default component.exports